<nav
  *ngIf="!mobile || mobileMenuOpen"
  class="primary-nav"
  [class.hovered]="
    expanded ||
    hovered ||
    inMenu ||
    headerMenuIsOpen ||
    profileMenuIsOpen ||
    ellipsesMenuIsOpen
  "
  [ngClass]="menuThemeColor"
  (touchstart)="!mobile ? addHover() : null"
  (mouseenter)="!mobile ? addHover() : null"
  (mouseleave)="!mobile ? removeHover() : null"
  role="navigation"
  aria-label="Primary navigation"
>
  <div class="logo-box">
    <div class="basin-display-flex basin-align-items-center">
      <div
        *ngIf="displayHeaderIcon"
        class="navmenu-ellipses icon-apps logo"
        [class]="menuThemeColor"
        [class.selected]="headerMenuIsOpen"
        (click)="headerMenu.toggle($event)"
      >
        <p-menu
          #headerMenu
          [popup]="true"
          styleClass="navmenu-app-list-menu"
          [model]="headerMenuItems"
          appendTo="body"
          (onShow)="headerMenuIsOpen = true"
          (onHide)="headerMenuIsOpen = false"
        ></p-menu>
      </div>

      <basin-navmenu-stantec-icon
        *ngIf="!displayHeaderIcon"
        class="logo"
        [class.basin-cursor-pointer]="stantecLensClickable"
        (click)="stantecLensClickable ? stantecLensClicked($event) : null"
      ></basin-navmenu-stantec-icon>

      <img
        *ngIf="
          logo &&
          (expanded ||
            hovered ||
            inMenu ||
            headerMenuIsOpen ||
            profileMenuIsOpen ||
            ellipsesMenuIsOpen)
        "
        class="logo"
        [src]="logo"
        alt="logo"
        [class.basin-cursor-pointer]="logoClickable"
        (click)="logoClickable ? logoClicked($event) : null"
      />

      <div
        *ngIf="!logo && homeLinkText && homeLink"
        class="basin-body-small home-link-text"
        [class.basin-cursor-pointer]="homeLinkClickable"
        (click)="homeLinkClickable ? homeLinkClicked($event) : null"
      >
        {{ homeLinkText }}
      </div>

      <basin-navmenu-stantec-logo
        *ngIf="
          !logo &&
          !homeLinkText &&
          homeLink &&
          (expanded ||
            hovered ||
            inMenu ||
            headerMenuIsOpen ||
            profileMenuIsOpen ||
            ellipsesMenuIsOpen)
        "
        [class.basin-cursor-pointer]="homeLinkClickable"
        (click)="homeLinkClickable ? homeLinkClicked($event) : null"
      ></basin-navmenu-stantec-logo>
    </div>
    <p-button
      *ngIf="!mobile"
      (click)="expanded ? removeDock() : addDock()"
      class="display-nav-button"
      styleClass="display-nav"
      [rounded]="true"
      [icon]="
        expanded ? 'icon-keyboard-arrow-left' : 'icon-keyboard-arrow-right'
      "
    ></p-button>
    <p-button
      *ngIf="mobile"
      (click)="expanded ? removeDock() : addDock()"
      class="display-nav-button"
      styleClass="hide-mobile"
      [text]="true"
      icon="icon-close"
    ></p-button>
  </div>
  <div class="navmenu-dropdown" *ngIf="dropdownMenuItems?.length > 0">
    <div
      (click)="
        mappedDropdownMenuItems.length > 1 &&
          dropdownMenuSelector.toggle($event)
      "
      class="navmenu-dropdown-menu"
      [class.basin-cursor-pointer]="mappedDropdownMenuItems?.length > 1"
    >
      <span
        [class]="selectedDropdownMenuItem?.icon"
        class="selected-icon"
      ></span>
      <div
        *ngIf="
          expanded ||
          hovered ||
          inMenu ||
          headerMenuIsOpen ||
          profileMenuIsOpen ||
          ellipsesMenuIsOpen
        "
        style="width: 96px; display: flex; flex-direction: column"
      >
        <span class="header-text">{{ selectedDropdownMenuItem?.label }}</span>
        <span class="selected-value">{{
          selectedDropdownMenuItem?.applicationName
        }}</span>
      </div>

      <span
        *ngIf="
          (expanded ||
            hovered ||
            inMenu ||
            headerMenuIsOpen ||
            profileMenuIsOpen ||
            ellipsesMenuIsOpen) &&
          mappedDropdownMenuItems?.length > 1
        "
        class="icon-arrow-drop-down dropdown-icon"
      ></span>
    </div>
    <p-menu
      #dropdownMenuSelector
      [popup]="true"
      appendTo="body"
      [model]="mappedDropdownMenuItems"
      (onShow)="inMenu = true"
      (onHide)="inMenu = false"
      styleClass="navmenu-dropdown-menu-selector"
    ></p-menu>
  </div>
  <div
    class="divider-box basin-pb-5"
    *ngIf="dropdownMenuItems?.length != 0"
  ></div>

  <div class="navmenu-body" #scrollBody>
    <p-accordion
      *ngIf="navItems?.length > 1"
      [multiple]="true"
      class="navmenu-accordion-body"
      [activeIndex]="[0, 1]"
      expandIcon="icon-expand-more"
      collapseIcon="icon-expand-less"
    >
      <ng-container *ngFor="let navItem of navItems; let i = index">
        <!-- Render the item based on whether it has a header or not -->
        <ng-container *ngIf="navItem.header; else menuOnly">
          <p-accordionTab [header]="navItem.header">
            <p-menu
              class="navigation navmenu-navigation"
              [styleClass]="mobileMenuOpen ? 'menu-open' : ''"
              [model]="navItem?.menuItems"
              (click)="toggleMenu()"
            ></p-menu>
          </p-accordionTab>
        </ng-container>

        <ng-template #menuOnly>
          <p-menu
            [styleClass]="
              mobileMenuOpen
                ? ' basin-overflow-hidden menu-open'
                : 'basin-overflow-hidden '
            "
            [model]="navItem?.menuItems"
            (click)="toggleMenu()"
          ></p-menu>
        </ng-template>

        <div
          class=""
          [ngClass]="
            hasScrollbar ? 'navgroup-divider-box-scroll' : 'divider-box'
          "
          *ngIf="shouldAddDivider(i)"
        >
          <div class="navgroup-divider"></div>
        </div>
      </ng-container>
    </p-accordion>

    <p-menu
      *ngIf="navItems?.length === 1"
      class="navigation navmenu-navigation"
      [styleClass]="mobileMenuOpen ? 'menu-open' : ''"
      [model]="navItems[0]?.menuItems"
      (click)="toggleMenu()"
    ></p-menu>
  </div>
  <div class="footer">
    <div
      *ngIf="showProfile"
      class="navmenu-user"
      [ngClass]="profileMenuItems?.length > 0 ? 'basin-cursor-pointer' : ''"
      (click)="
        profileMenuItems?.length > 0 ? profileMenu.toggle($event) : false
      "
    >
      <img
        *ngIf="
          userProfile != null &&
          userProfile != undefined &&
          userProfile.image &&
          userProfile.image !== ''
        "
        [src]="userProfile.image"
        class="navmenu-profile-image"
        alt=""
      />
      <div
        class="navmenu-user-overlay"
        [class.user-icon]="
          userProfile == null ||
          userProfile == undefined ||
          !userProfile.image ||
          userProfile.image === ''
        "
      ></div>
      <basin-circled-icon
        *ngIf="
          userProfile == null ||
          userProfile == undefined ||
          !userProfile.image ||
          userProfile.image === ''
        "
        size="medium"
        icon="icon-person"
        iconColor="var(--neutral-color-mid-gray)"
        backgroundColor="var(--neutral-color-lightest-gray)"
      ></basin-circled-icon>
      <span
        class="navmenu-user-profile-text"
        *ngIf="
          expanded ||
          hovered ||
          inMenu ||
          headerMenuIsOpen ||
          profileMenuIsOpen ||
          ellipsesMenuIsOpen
        "
        >{{ userProfile.name }}</span
      >
      <p-menu
        #profileMenu
        [popup]="true"
        [model]="profileMenuItems"
        appendTo="body"
        (onShow)="profileMenuIsOpen = true"
        (onHide)="profileMenuIsOpen = false"
      ></p-menu>
    </div>
    <div
      style="display: flex"
      [ngClass]="
        (expanded || hovered) &&
        (!ellipsesMenu || !ellipsesMenuItems || ellipsesMenuItems?.length < 1
          ? 'basin-width-100'
          : '')
      "
    >
      <p-menu
        class="nav-footer-menu"
        [styleClass]="mobileMenuOpen ? 'menu-open' : ''"
        [model]="footerMenuItems"
      ></p-menu>
      <div
        *ngIf="
          ellipsesMenu &&
          ellipsesMenuItems &&
          ellipsesMenuItems?.length > 0 &&
          (expanded ||
            hovered ||
            inMenu ||
            headerMenuIsOpen ||
            profileMenuIsOpen ||
            ellipsesMenuIsOpen)
        "
        class="navmenu-ellipses icon-more-horiz"
        [class]="menuThemeColor"
        [class.selected]="ellipsesMenuIsOpen"
        (click)="ellipsesMenu.toggle($event)"
      >
        <p-menu
          #ellipsesMenu
          [popup]="true"
          [model]="ellipsesMenuItems"
          appendTo="body"
          (onShow)="ellipsesMenuIsOpen = true"
          (onHide)="ellipsesMenuIsOpen = false"
        ></p-menu>
      </div>
    </div>
  </div>
</nav>
<nav
  *ngIf="mobile"
  class="primary-nav mobile-nav"
  aria-label="Primary navigation"
>
  <button class="hamburger-menu" (click)="toggleMenu()" aria-label="Menu">
    <span class="hamburger-menu-line" [class.menu-open]="mobileMenuOpen"></span>
  </button>
  <div class="page-title basin-body-small">
    {{ currentPageTitle }}
  </div>
</nav>
<div class="mobile-backdrop" *ngIf="mobile && mobileMenuOpen"></div>
